module.exports = __webpack_public_path__ + "static/img/game_po2.666eeb9.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/game_po2.gif
// module id = uuPp
// module chunks = 1